module.exports = __webpack_public_path__ + "static/img/vr5.0f19c358.png";